/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StopChatStreamResponseDto
 */
export interface StopChatStreamResponseDto {
    /**
     * Status of the stop request
     * @type {string}
     * @memberof StopChatStreamResponseDto
     */
    status: string;
    /**
     * The active chat stream ID
     * @type {string}
     * @memberof StopChatStreamResponseDto
     */
    streamId: string;
}

/**
 * Check if a given object implements the StopChatStreamResponseDto interface.
 */
export function instanceOfStopChatStreamResponseDto(value: object): value is StopChatStreamResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('streamId' in value) || value['streamId'] === undefined) return false;
    return true;
}

export function StopChatStreamResponseDtoFromJSON(json: any): StopChatStreamResponseDto {
    return StopChatStreamResponseDtoFromJSONTyped(json, false);
}

export function StopChatStreamResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StopChatStreamResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'streamId': json['streamId'],
    };
}

export function StopChatStreamResponseDtoToJSON(json: any): StopChatStreamResponseDto {
    return StopChatStreamResponseDtoToJSONTyped(json, false);
}

export function StopChatStreamResponseDtoToJSONTyped(value?: StopChatStreamResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'streamId': value['streamId'],
    };
}

